module.exports = __webpack_public_path__ + "138c8b3fc76d31e6df791d211f382f0d.png";